/**
 * AI 스타일 프리셋 — Gemini img2img 프롬프트 + Veo 영상 프롬프트 번들.
 * 런타임에 booth-api의 DynamoDB 테이블 fiket-booth-styles로 관리.
 * MOCK_AI_STYLES는 초기 seed + 클라이언트 폴백 용도로만 유지.
 */
/** 라이브러리(부스 없는 스타일 저장소) 스코프 id — AIStyle.boothId 에 들어간다 (BOOTH-113). 부스 id(UUID)·"default" 와 충돌하지 않는다. */
export const LIBRARY_SCOPE_ID = "__library__";
/**
 * 키오스크·공개·admin 경로가 라이브러리 스코프 레코드를 숨기는 데 쓴다 (BOOTH-113, 스펙 §4.3).
 * boothId 가 LIBRARY_SCOPE_ID 와 정확히 일치하는지 반환한다.
 */
export function isLibraryScope(boothId) {
    return boothId === LIBRARY_SCOPE_ID;
}
/**
 * 키오스크·공개·admin 경로가 라이브러리 스코프 레코드를 숨기는 데 쓴다 (BOOTH-113, 스펙 §4.3).
 * 스타일의 boothId 가 라이브러리 스코프이면 true 를 반환한다.
 */
export function isLibraryStyle(style) {
    return isLibraryScope(style.boothId);
}
const FACE_PRESERVE = "Keep the person's face and pose identical to the input photo, preserve their identity, only change the outfit and background.";
export const MOCK_AI_STYLES = [
    {
        id: "hanbok",
        themeId: "theme_hanbok",
        sortOrder: 10,
        name: "한복",
        description: "전통 한복 차림",
        nameEn: "Hanbok",
        descriptionEn: "Traditional Hanbok attire",
        thumbnailUrl: "/styles/hanbok.jpg",
        isEnabled: true,
        videoEnabled: true,
        videoPrompt: "Silk hanbok sleeves and skirt gently flowing in a soft breeze. Subject gives a subtle smile and small head turn. Palace courtyard in background with cherry blossom petals drifting slowly through the frame. Warm, cinematic daylight. 8-second loop-friendly motion.",
        prompt: `${FACE_PRESERVE}
Transform into traditional Korean Hanbok attire.
Wearing elegant silk Hanbok with vibrant traditional colors (jade green top, coral skirt).
Background: traditional Korean palace courtyard with hanok architecture, soft daylight.
Style: warm natural lighting, photorealistic.`,
    },
    {
        id: "joseon_scholar",
        themeId: "theme_royal",
        sortOrder: 20,
        name: "조선 사대부",
        description: "조선 양반 초상화",
        nameEn: "Joseon Scholar",
        descriptionEn: "Joseon aristocrat portrait",
        thumbnailUrl: "/styles/joseon_scholar.jpg",
        isEnabled: true,
        videoEnabled: true,
        videoPrompt: "Ink brush strokes animate into place around the portrait, bamboo silhouettes sway gently in the background. Subject holds a steady, dignified gaze. Ink wash shifts as if lifted by a faint wind. Subtle rim light. 8-second subtle motion.",
        prompt: `${FACE_PRESERVE}
Transform into a Joseon Dynasty scholar portrait.
Wearing traditional gat (black horsehair hat) and white dopo robe with jade accent.
Background: ink wash painting style with bamboo and mountain silhouettes.
Style: classical Korean portrait painting aesthetic, muted tones.`,
    },
    {
        id: "kpop_idol",
        themeId: "theme_kpop",
        sortOrder: 10,
        name: "K-pop 아이돌",
        description: "스튜디오 화보 스타일",
        nameEn: "K-pop Idol",
        descriptionEn: "Studio photoshoot style",
        thumbnailUrl: "/styles/kpop_idol.jpg",
        isEnabled: true,
        videoEnabled: true,
        videoPrompt: "Rhythmic shoulder bounce and confident smile as if moving to an imagined beat. Studio lights pulse in pastel gradients. Hair catches slight motion. High-fashion magazine feel. 8-second energetic loop.",
        prompt: `${FACE_PRESERVE}
Transform into a K-pop idol photoshoot.
Wearing trendy modern Korean fashion, glamorous stage makeup, styled hair.
Background: vibrant studio lighting with pastel gradient backdrop.
Style: high-fashion editorial, glossy magazine finish.`,
    },
    {
        id: "historical_drama",
        themeId: "theme_royal",
        sortOrder: 10,
        name: "사극",
        description: "궁중 사극 스틸컷",
        nameEn: "Sageuk",
        descriptionEn: "Royal court drama still",
        thumbnailUrl: "/styles/historical_drama.jpg",
        isEnabled: true,
        videoEnabled: true,
        videoPrompt: "Slow cinematic dolly-in toward the subject. Candlelight flickers across the throne room, gold dragon motifs glinting. Subject maintains a regal expression with the slightest head movement. Period drama color grade. 8-second slow push-in.",
        prompt: `${FACE_PRESERVE}
Transform into a Korean historical drama (sageuk) still frame.
Wearing royal court attire — if appears male: king's yongpo robe; if female: queen's dangui with binyeo hairpin.
Background: lavish Joseon palace throne room with gold dragon motifs.
Style: cinematic film lighting, dramatic shadows, period film grade.`,
    },
    {
        id: "cyber_seoul",
        // themeId 없음 → 미분류 테마 (lazy default 동작 확인용)
        sortOrder: 10,
        name: "사이버 서울",
        description: "네온 사이버펑크",
        nameEn: "Cyber Seoul",
        descriptionEn: "Neon cyberpunk",
        thumbnailUrl: "/styles/cyber_seoul.jpg",
        isEnabled: true,
        videoEnabled: true,
        videoPrompt: "Neon hologram signs flicker behind the subject. Slow-motion rain drops fall through the frame. Subject slightly tilts head, holographic glitch accents shimmer across the edges. Teal and magenta color grade. 8-second moody loop.",
        prompt: `${FACE_PRESERVE}
Transform into a cyberpunk Seoul portrait.
Wearing futuristic Korean streetwear with LED accents and holographic fabric.
Background: neon-lit Gangnam streets at night, holographic Hangul signage.
Style: Blade Runner meets K-pop, teal and magenta color grading.`,
    },
];
//# sourceMappingURL=ai-style.js.map